import type { FeedEvent } from "@/types/feed";

/** Event types withheld from Client (consignee portal) feeds — mirrors Rust `CLIENT_PORTAL_RESTRICTED_FEED_EVENT_TYPES`. */
const CLIENT_RESTRICTED_EVENT_TYPES = new Set([
  "rebook_opportunity",
  "first_book",
  "rebook_confirm",
  "rebook_progress",
  "commercial_digest",
  "rate_cards_ingested",
  "alert_fired",
  "insight_snapshot",
  "pattern_detected",
  "batch_ingested",
  "custom_event",
  "new_booking",
  "recommendations_produced",
  "search_cycle_completed",
  "allocation_impact",
  "data_source_stale",
  "tracking_dropped",
]);

const CLIENT_RESTRICTED_PAYLOAD_KINDS = new Set([
  "booking_opportunity",
  "commercial_digest",
  "graph_mail",
  "new_booking_mail",
]);

/** Whether a feed row should render for a Client user (belt-and-suspenders with API). */
export function isClientRestrictedFeedEvent(event: {
  event_type: string;
  source?: string;
  payload?: unknown;
}): boolean {
  if (CLIENT_RESTRICTED_EVENT_TYPES.has(event.event_type)) return true;
  const payload = event.payload;
  if (!payload || typeof payload !== "object") return false;
  const kind = (payload as { kind?: string }).kind;
  if (kind && CLIENT_RESTRICTED_PAYLOAD_KINDS.has(kind)) return true;
  if (
    event.source === "external" &&
    kind &&
    CLIENT_RESTRICTED_PAYLOAD_KINDS.has(kind)
  ) {
    return true;
  }
  return false;
}

export function filterFeedEventsForClient<T extends FeedEvent>(
  events: T[],
  isClient: boolean,
): T[] {
  if (!isClient) return events;
  return events.filter((e) => !isClientRestrictedFeedEvent(e));
}
